/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ClientContactWithDetails } from './ClientContactWithDetails';
import {
	ClientContactWithDetailsFromJSON,
	ClientContactWithDetailsFromJSONTyped,
	ClientContactWithDetailsToJSON,
} from './ClientContactWithDetails';

/**
 *
 * @export
 * @interface ClientContactResponse
 */
export interface ClientContactResponse {
	/**
	 *
	 * @type {ClientContactWithDetails}
	 * @memberof ClientContactResponse
	 */
	clientContact?: ClientContactWithDetails;
}

/**
 * Check if a given object implements the ClientContactResponse interface.
 */
export function instanceOfClientContactResponse(value: object): boolean {
	let isInstance = true;

	return isInstance;
}

export function ClientContactResponseFromJSON(json: any): ClientContactResponse {
	return ClientContactResponseFromJSONTyped(json, false);
}

export function ClientContactResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): ClientContactResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		clientContact: !exists(json, 'clientContact')
			? undefined
			: ClientContactWithDetailsFromJSON(json['clientContact']),
	};
}

export function ClientContactResponseToJSON(value?: ClientContactResponse | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		clientContact: ClientContactWithDetailsToJSON(value.clientContact),
	};
}
